import { config } from '../../../../shared/config';
import { environment } from '../../environments/environment';

export function generateOGImage(
  title: string,
  description: string,
  sportType: string,
  about: 'Club' | 'Event' | 'Session' | 'Tournament' | 'Venue' | 'Marketplace' | 'Coach' | 'Match' | 'Sponsor'
): string {
  const ogTitle = encodeURIComponent(truncateWithEllipsis(title, 50));
  const ogDescription = encodeURIComponent(
    truncateWithEllipsis(description, 70)
  );

  const ogImageUrl = `${environment.serverUrl}/api/og/og-image?title=${ogTitle}&subtitle=${ogDescription}&sportType=${sportType}&about=${about}`;
  return ogImageUrl;
}

export function generateMatchOGImage(matchId: string): string {
  return `${environment.serverUrl}/api/og/match-image?id=${matchId}`;
}

function truncateWithEllipsis(text: string, maxLength: number): string {
  return text.length > maxLength
    ? text.slice(0, maxLength - 1).trim() + '…'
    : text;
}
